import { styled } from '@mui/system';
import { FormControl, MenuItem } from '@mui/material';
import { BASE_FIELD_BACKGROUND_COLOR } from '../../themes/tokens';

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    minHeight: '36px',
  },
}));

export const StyledFormControl = styled(FormControl)`
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
`;
